import React from 'react';

import PropTypes from 'prop-types';
import CSSModule from 'react-css-modules';

import { Button } from 'components';

import styles from './EmailTemplatePreview.module.scss';

const EmailTemplatePreview = ({
    subject,
    html,
    onHide,
}) => {
    return (
        <div styleName="preview">
            <div styleName="previewHeader">
                <h4>Email Preview</h4>

                <Button
                    outline
                    type="button"
                    onClick={onHide}
                >
                    Hide Preview
                </Button>
            </div>

            <div styleName="previewMeta">
                <strong>Subject:</strong>

                <div>
                    {subject || 'No subject'}
                </div>
            </div>

            <div styleName="previewContainer">
                <div
                    styleName="previewEmail"
                    dangerouslySetInnerHTML={{
                        __html: html,
                    }}
                />
            </div>
        </div>
    );
};

EmailTemplatePreview.propTypes = {
    subject: PropTypes.string,
    html: PropTypes.string,
    onHide: PropTypes.func.isRequired,
};

EmailTemplatePreview.defaultProps = {
    subject: '',
    html: '',
};

export default CSSModule(
    EmailTemplatePreview,
    styles,
    { allowMultiple: true }
);